import { EThemeDefaultEditorCanvasLegacy } from "./e-theme-default-editor-canvas-legacy";

export class EThemeDefaultEnUsEditorCanvasLegacy extends EThemeDefaultEditorCanvasLegacy {}
